// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:24
import { ScheduledServiceResource_abstract } from './../abstract/SagaSchema/ScheduledServiceResource_abstract';
export class ScheduledServiceResource extends ScheduledServiceResource_abstract {}
